import { Methods } from '../../api/methods.js';
import type { ParsedArgs } from '../args.js';
import { flag } from '../args.js';
import { CliError, ExitCode } from '../errors.js';
import type { CommandResult } from '../output.js';
import { readSecret } from '../secret.js';
import { pickDefined, request } from './common.js';

export async function authCommand(args: ParsedArgs): Promise<CommandResult> {
  const action = args.positionals[1] ?? 'status';
  switch (action) {
    case 'claim': {
      const providedToken = flag(args.flags, 'token');
      if (providedToken !== undefined && providedToken !== '-') {
        throw new CliError(
          '--token accepts only -; provide claim token through prompt or stdin',
          ExitCode.Usage,
        );
      }
      const token = await readSecret('Core claim token: ');
      if (!token) throw new CliError('auth claim requires a token', ExitCode.Usage);
      return request(args, Methods.SettingsAuthClaim, {
        claimUrl: required(args, 'claim-url'),
        token,
      });
    }
    case 'status':
      return request(args, Methods.SettingsAuthStatus, { url: required(args, 'url') });
    case 'unlink':
      return request(args, Methods.SettingsAuthUnlink);
    case 'link':
      return request(args, Methods.SettingsAuthLink, pickDefined({ url: flag(args.flags, 'url') }));
    case 'link-status':
      return request(args, Methods.SettingsAuthLinkStatus);
    case 'link-cancel':
      return request(args, Methods.SettingsAuthLinkCancel);
    default:
      throw new CliError(`Unknown auth action "${action}"`, ExitCode.Usage);
  }
}

function required(args: ParsedArgs, name: string): string {
  const value = flag(args.flags, name);
  if (!value) throw new CliError(`--${name} is required`, ExitCode.Usage);
  return value;
}
